import { useState, useEffect } from 'react';
import { Trans, useTranslation } from "react-i18next";

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';

import Typescript from '@mui/material/Typography'

import Title from '../../components/Title'
import Text from '../../components/Text'

import ImageGallery from "react-image-gallery";
import Snackbar from "@mui/material/Snackbar";
import "../../css/image-gallery.css";

//import slides from '../../data/images.json'

function Pictures() {

  const { t, i18n } = useTranslation();

  /*
    C_briandwise_iNaturalist.png  confronto.png		       Fillodia_in_Calendula_officinalis.png
    C_Filip_Kawa_iNaturalist.png  C_pinustaeda_iNaturalist.png     Fragole.png
    C_mahpin_iNaturalist.png      C_Steve_Collins_iNaturalist.png
  */

const slides = [
    {
        "original": "../../symptoms/confronto.png",
        "thumbnail": "../../symptoms/confronto.png",
        "alt": "Virescenza su un fiore di echinacea / Vireszenz auf Sonnenhut",
        "description": i18n.language === "it" ? "Pianta di pomodoro San Marzano infetta da fitoplasmi. In alto: normale struttura del fiore di una pianta sana. In basso: infiorescenza deformata con fillodia e colorazione violacea." : "Phytoplasmen-infizierten Tomaten ('San Marzano'). Oben: Normale Blütenstruktur einer gesunden Pflanze. Unten: Stark deformierter Blütenstand mit typischen blattartigen Blüten (Phyllodie) und purpurfarbener Verfärbung.",
    },
    {
        "original": "../../symptoms/C_pinustaeda_iNaturalist.png",
        "thumbnail": "../../symptoms/C_pinustaeda_iNaturalist.png",
        "alt": "Virescenza su un fiore di echinacea / Vireszenz auf Sonnenhut",
        "description": i18n.language === "it" ? "Virescenza su un fiore di echinacea" : "Vireszenz bei Sonnenhut"
    },
    {
        "original": "../../symptoms/C_Steve_Collins_iNaturalist.png",
        "thumbnail": "../../symptoms/C_Steve_Collins_iNaturalist.png",
        "alt": "Virescenza su un fiore di echinacea / Vireszenz auf Sonnenhut",
        "description": i18n.language === "it" ?  "Scopazzi  su un albero di pino" : "Hexenbesen bei Kiefer"
    },
    {
        "original": "../../symptoms/C_Filip_Kawa_iNaturalist.png",
        "thumbnail": "../../symptoms/C_Filip_Kawa_iNaturalist.png",
        "alt": "Virescenza su un fiore di echinacea / Vireszenz auf Sonnenhut",
        "description": i18n.language === "it" ?  "Scopazzi su un albero di pino" : "Hexenbesen bei Kiefer"
    },
    {
        "original": "../../symptoms/C_briandwise_iNaturalist.png",
        "thumbnail": "../../symptoms/C_briandwise_iNaturalist.png",
        "alt": "Virescenza su un fiore di echinacea / Vireszenz auf Sonnenhut",
        "description": i18n.language === "it" ?  "Virescenza su un fiore di echinacea" : "Vireszenz auf Sonnenhut"
    },
    {
        "original": "../../symptoms/C_mahpin_iNaturalist.png",
        "thumbnail": "../../symptoms/C_mahpin_iNaturalist.png",
        "alt": "Virescenza su un fiore di echinacea / Vireszenz auf Sonnenhut",
        "description": i18n.language === "it" ? "Fillodia su un fiore di echinacea" : "Phyllodie bei Sonnenhut"
    },
    {
        "original": "../../symptoms/Fragole.png",
        "thumbnail": "../../symptoms/Fragole.png",
        "alt": "Virescenza su un fiore di echinacea / Vireszenz auf Sonnenhut",
        "description": i18n.language === "it" ? "Fillodia su una fragola": "Phyllodie auf Erdbeer"
    },
    {
        "original": "../../symptoms/Fillodia_in_Calendula_officinalis.png",
        "thumbnail": "../../symptoms/Fillodia_in_Calendula_officinalis.png",
        "alt": "Virescenza su un fiore di echinacea / Vireszenz auf Sonnenhut",
        "description": i18n.language === "it" ? "Fillodia su un fiore di calendula " : "Phyllodie bei Ringelblume",
        "originalHeight" : "100"
    },
    {
        "original": "../../symptoms/Vergilbung.jpg",
        "thumbnail": "../../symptoms/Vergilbung.jpg",
        "alt": "Virescenza su un fiore di echinacea / Vireszenz auf Sonnenhut",
        "description": i18n.language === "it" ? "Le foglie assumono una colorazione giallastra e tendono ad accartocciarsi." : "Die Blätter nehmen eine gelbliche Färbung an und rollen sich teilweise ein.",
        "originalHeight" : "100"
    },
]

  return (

    <Container className="brown pt-2">

      <Text
        text="pictures_title"
        color="beige"
        variant="normal" />

      <Grid
        container
        flexDirection="row"
        justifyContent="center"

        className="px-0 center">

        <Grid className="p-3 " size={{ xs: 12, sm: 12, md: 9 }}>

          <Box className="whiteborder">

            <ImageGallery
              items={slides}
              lazyLoad={true}
              thumbnailPosition="top"
              showPlayButton={false}
              showBullets={false}
              autoPlay={false}
              showThumbnails={false}
              showFullscreenButton={false}
              showIndex={true}
              originalHeight={"200"}
            />

          </Box>

        </Grid>

      </Grid>

    </Container>
  );
}

export default Pictures;
